import { useFormikContext } from "formik";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

function useConfirmExit(confirmExit: () => boolean, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) {
      return;
    }

    const push = navigator.push;

    navigator.push = (...args) => {
      const result = confirmExit();
      if (result !== false) {
        push(...args);
      }
    };

    return () => {
      navigator.push = push;
    };
  }, [navigator, confirmExit, when]);
}

export function usePrompt(message: string, when = true) {
  useEffect(() => {
    if (when) {
      window.onbeforeunload = function () {
        return message;
      };
    }

    return () => {
      window.onbeforeunload = null;
    };
  }, [message, when]);

  const confirmExit = useCallback(() => {
    const confirm = window.confirm(message);
    return confirm;
  }, [message]);
  useConfirmExit(confirmExit, when);
}

// export function useBlocker(blocker, when = true) {
//   const navigator = useContext(UNSAFE_NavigationContext).navigator;

//   useEffect(() => {
//     if (!when) return;

//     const unblock = navigator.block((tx) => {
//       const autoUnblockingTx = {
//         ...tx,
//         retry() {
//           unblock();
//           tx.retry();
//         },
//       };

//       blocker(autoUnblockingTx);
//     });

//     return unblock;
//   }, [navigator, blocker, when]);
// }

// Custom hook since React-router v6 doesnt support this feature anymore
// function useCallbackPrompt(when) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [showPrompt, setShowPrompt] = useState(false);
//   const [lastLocation, setLastLocation] = useState(null);
//   const [confirmedNavigation, setConfirmedNavigation] = useState(false);

//   const cancelNavigation = useCallback(() => {
//     setShowPrompt(false);
//   }, []);

//   // handle blocking when user click on another route prompt will be shown
//   const handleBlockedNavigation = useCallback(
//     (nextLocation) => {
//       // in if condition we are checking next location and current location are equals or not
//       if (
//         !confirmedNavigation &&
//         nextLocation.location.pathname !== location.pathname
//       ) {
//         setShowPrompt(true);
//         setLastLocation(nextLocation);
//         return false;
//       }
//       return true;
//     },
//     [confirmedNavigation]
//   );

//   const confirmNavigation = useCallback(() => {
//     setShowPrompt(false);
//     setConfirmedNavigation(true);
//   }, []);

//   useEffect(() => {
//     if (confirmedNavigation && lastLocation) {
//       navigate(lastLocation.location.pathname);
//     }
//   }, [confirmedNavigation, lastLocation]);

//   useBlocker(handleBlockedNavigation, when);

//   return [showPrompt, confirmNavigation, cancelNavigation];
// }

export const DialogLeavingPage = () => {
  const { dirty } = useFormikContext();
  // const [showDialog, setShowDialog] = useState(false);
  const { t } = useTranslation();
  // const [showPrompt, confirmNavigation, cancelNavigation] =
  //   useCallbackPrompt(showDialog);

  // useEffect(() => {
  //   setShowDialog(dirty);
  // }, [dirty]);

  usePrompt(t("dialogs.leavingPageText2"), dirty);
  return null;
  // <AreYouSureDialog
  //   isDialogOpen={showPrompt}
  //   handleClose={cancelNavigation}
  //   title={t("dialogs.leavingPageTitle")}
  //   content={
  //     <>
  //       <Typography>{t("dialogs.leavingPageText1")}</Typography>
  //       <Typography>{t("dialogs.leavingPageText2")}</Typography>
  //       <Typography>{t("dialogs.leavingPageText3")}</Typography>
  //     </>
  //   }
  //   onSubmit={confirmNavigation}
  // />
};
